import { useQuery } from 'react-query';
import { TableConfigType } from '../../types/configTypes';
import { createFetchAPI } from '../http';

const endpoint = '/v1/fave_passes';

export type FavePassesRequestType = TableConfigType & {
  company_id: number;
};

export type CompanyOutletScopePayloadType = {
  company_id: number;
};

type FavePassesResponseType = {
  fave_passes: FetchFavePassesDataResponse[];
  count: number;
};

export type FetchFavePassesDataResponse = {
  id: number;
  name: string;
  total_sessions: number;
  validity: number;
};

const fetchFavePasses = createFetchAPI<
  FavePassesRequestType,
  FavePassesResponseType
>(endpoint);

export const useFetchFavePasses = (props: FavePassesRequestType) =>
  useQuery<FavePassesResponseType>(
    ['fetchFavePasses', { ...props }],
    fetchFavePasses,
    { staleTime: 0 },
  );
